export function formatDate(inputDateTime) {
    const date = new Date(inputDateTime);
    if (isNaN(date)) {
        throw new Error('Invalid date format');
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

// 현재 날짜를 YYYY-MM-DD 형식으로 변환하는 함수
export function getCurrentDateFormatted() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 1을 더해줌
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}



export function getCurrentYear1Q() {
    const date = new Date();
    const year = date.getFullYear();    
    return `${year}-03-01`;
}

export function getCurrentYear2Q() {
    const date = new Date();
    const year = date.getFullYear();
    return `${year}-06-01`;
}

export function getCurrentYear3Q() {
    const date = new Date();
    const year = date.getFullYear();
    return `${year}-09-01`;
}

export function getCurrentYear4Q() {
    const date = new Date();
    const year = date.getFullYear();
    return `${year}-12-01`;
}

export function getCurrentYearFirstDay() {
    const date = new Date();
    const year = date.getFullYear();
    return `${year}-01-01`;
}

export function getCurrentYearLastDay() {
    const date = new Date();
    const year = date.getFullYear();
    return `${year}-12-31`;
}

export const calculateDateDifference = (startDate, endDate) => {
    if (!startDate || !endDate) return '';
    const start = new Date(startDate);
    const end = new Date(endDate);
    const differenceInTime = end - start;
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return differenceInDays;
};